import store from "@/store";
import request from "@/utils/request";



export async function getSsoUserList(params) {
    console.log("@@ get list : getSsoUserList");
    let result = request.get("/api/sso/ssoUser/",{params});
    return result;
}

export async function getSsoUserItem(params) {
    console.log("@@ get item : getSsoUserItem");
    let result = request.get(`/api/sso/ssoUser/${params.userSeq}`,{params} );
    return result;
}

export async function saveSsoUser(params) {
    console.log("@@ post save : saveSsoUser");
    let result = request.post(`/api/sso/ssoUser/`,params);
    return result;
}

export async function deleteSsoUser(params) {
    console.log("@@ delete : deleteSsoUser");
    let result = request.delete(`/api/sso/ssoUser/${params.userSeq}`,{params});
    return result;
}
